/**
 * Hình thức nộp
 */
export default {
  Offline: 1,
  Online: 0,
}
